import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'react-final-form';
import {
  DateField,
  DurationField,
  RadioField,
} from '@unite-us/app-components';
import { useIsClientsDrawer } from '../../context/InteractionsContext';
import {
  DRAWER_PERIOD_OPTIONS,
  FIELD_NAMES,
  LABEL_CLASSNAME,
  PERIOD_TYPE,
  PERIOD_OF_SERVICE_OPTIONS,
} from '../../constants';

const toFormDateValue = (momentValue) => momentValue.utc().format('MM/DD/YYYY');

const getRadioOptions = (isClientsDrawer) => (
  isClientsDrawer ? DRAWER_PERIOD_OPTIONS : PERIOD_OF_SERVICE_OPTIONS
);

const getDateStyle = (isClientsDrawer) => (
  isClientsDrawer ?
    {
      container: { width: '100%', maxWidth: '100%', boxSizing: 'border-box' },
      input: {
        width: '100%', maxWidth: '100%', height: '38px', boxSizing: 'border-box',
      },
      dropdown: { left: '50%', right: 'auto', transform: 'translateX(-50%)' },
    } :
    {
      container: { width: '60%', maxWidth: '60%', boxSizing: 'border-box' },
      input: {
        width: '100%', maxWidth: '100%', height: '38px', boxSizing: 'border-box',
      },
      dropdown: { right: 0, left: 'auto' },
    }
);

const getRangeStyle = (isClientsDrawer) => (
  isClientsDrawer ?
    {
      container: { width: '100%', maxWidth: '100%' },
      dropdown: { left: '50%', right: 'auto', transform: 'translateX(-50%)' },
    } :
    {
      container: { width: '60%', maxWidth: '60%' },
      dropdown: { right: 0, left: 'auto' },
    }
);

const getRangeClass = (isClientsDrawer) => (
  isClientsDrawer ?
    'mb-0 w-full [&_.w-64]:!w-full [&_.w-64]:!max-w-full [&_.absolute.top-0.right-0]:!hidden' :
    'mb-0 w-full [&_.w-64]:!w-full [&_.w-64]:!max-w-full'
);

export function PeriodOfServiceRow({ periodType }) {
  const isClientsDrawer = useIsClientsDrawer();

  return (
    <div className="grid w-full grid-cols-2 gap-x-6 gap-y-2 items-start">
      <div className="min-w-0">
        <Field name={FIELD_NAMES.periodType}>
          {({ input, meta }) => {
            const error = meta.touched && meta.error ? meta.error : undefined;

            return (
              <RadioField
                className="mb-0"
                error={error}
                id="structured-interaction-period-type"
                inline
                invalid={!!error}
                label="Period of Service"
                labelClassName={LABEL_CLASSNAME}
                onBlur={input.onBlur}
                onChange={input.onChange}
                options={getRadioOptions(isClientsDrawer)}
                required
                touched={meta.touched}
                value={input.value}
              />
            );
          }}
        </Field>
      </div>
      <div className="min-w-0">
        {periodType === PERIOD_TYPE.SINGLE && (
          <Field name={FIELD_NAMES.singleDate}>
            {({ input }) => (
              <DateField
                className="mb-0 w-full"
                id="structured-interaction-single-date"
                label="Date"
                labelClassName={LABEL_CLASSNAME}
                onBlur={input.onBlur}
                onChange={input.onChange}
                required
                style={getDateStyle(isClientsDrawer)}
                value={input.value}
                valueFormat={toFormDateValue}
              />
            )}
          </Field>
        )}
        {periodType === PERIOD_TYPE.RANGE && (
          <Field name={FIELD_NAMES.rangeStart}>
            {(startProps) => (
              <Field name={FIELD_NAMES.rangeEnd}>
                {(endProps) => (
                  <DurationField
                    buttonClassName="'min-w-0 w-full'"
                    className={getRangeClass(isClientsDrawer)}
                    style={getRangeStyle(isClientsDrawer)}
                    id="structured-interaction-date-range"
                    isUtc
                    label="Date"
                    labelClassName={LABEL_CLASSNAME}
                    onBlur={() => {
                      startProps.input.onBlur();
                      endProps.input.onBlur();
                    }}
                    startField={{
                      ...startProps,
                      meta: {
                        ...startProps.meta,
                        error: startProps.meta.touched ? startProps.meta.error : undefined,
                      },
                    }}
                    endField={{
                      ...endProps,
                      meta: {
                        ...endProps.meta,
                        error: endProps.meta.touched && endProps.meta.error && startProps.input.value ?
                          endProps.meta.error :
                          undefined,
                      },
                    }}
                    required={false}
                    valueFormat={toFormDateValue}
                  />
                )}
              </Field>
            )}
          </Field>
        )}
      </div>
    </div>
  );
}

PeriodOfServiceRow.propTypes = {
  periodType: PropTypes.string.isRequired,
};
